
document.addEventListener("DOMContentLoaded", function () {

const quiz = document.getElementById("creationQuiz");

if (!quiz) {
  console.log("creationQuiz form not found");
  return;
}

quiz.addEventListener("submit", function(e){

e.preventDefault();

const answers = new FormData(this);

let occasion = answers.get("occasion") || "";
let loss = answers.get("loss") || "";
let relationship = answers.get("relationship") || "";

let recommendation = "";


if (occasion.includes("Memorial") && loss.includes("Yes")) {

    recommendation =
    "We recommend exploring our Memorial Keepsakes Collection.";

}

else if (relationship === "Pet") {

    recommendation =
    "We recommend our Pet Memorial Collection.";

}

else if (occasion === "Birthday") {

    recommendation =
    "We recommend our Personalized Gift Collection.";

}

else {

    recommendation =
    "We recommend our Custom Creations Collection.";

}


document.getElementById("quizResult").innerHTML =
`
<h3>${recommendation}</h3>
<p>Thank you for sharing their story. We'll help you create something meaningful.</p>
`;

});

});


// document
// .getElementById("customDesignForm")
// .addEventListener("submit", async function(e){

// e.preventDefault();


// const form = document.getElementById("customDesignForm");

// const formData = new FormData();


// formData.append(
// "idea",
// form.idea.value
// );


// formData.append(
// "deadline",
// form.deadline.value
// );


// formData.append(
// "customerName",
// form.customerName.value
// );


// formData.append(
// "email",
// form.email.value
// );


// formData.append(
// "phone",
// form.phone.value
// );



// document
// .querySelectorAll('input[name="products"]:checked')
// .forEach(item => {

// formData.append(
// "products",
// item.value
// );

// });



// document
// .querySelectorAll('input[name="styles"]:checked')
// .forEach(item => {

// formData.append(
// "styles",
// item.value
// );

// });



// const files = document.getElementById("designFiles").files;


// for(let i = 0; i < files.length; i++){

// formData.append(
// "files",
// files[i]
// );

// }



// const result = document.getElementById("quizResult");


// result.innerHTML = "Sending your request...";


// try {


// const response = await fetch(
// "https://YOUR-BACKEND-URL/api/custom-design",
// {
// method:"POST",
// body:formData
// }
// );



// const data = await response.json();



// if(response.ok){


// result.innerHTML = `

// <h3>Thank you for your inquiry! ✨</h3>

// <p>
// Your custom design request has been successfully submitted.
// We will review your idea and get back to you as soon as possible.
// </p>

// <p>
// Thank you for choosing Fusion Creations By KG 💛
// </p>

// `;


// form.reset();


// }
// else {


// result.innerHTML = `
// <p>
// Something went wrong. Please try again.
// </p>
// `;

// }



// }

// catch(error){

// console.error(error);


// result.innerHTML = `

// <p>
// We were unable to submit your request.
// Please try again later.
// </p>

// `;

// }


// });


// customdesign
// document.addEventListener("DOMContentLoaded", function () {

//   console.log("Custom design script loaded");

//   const form = document.getElementById("customDesignForm");
//   const result = document.getElementById("customDesignResult");


//   if (!form) {
//     console.log("Custom design form not found");
//     return;
//   }


//   console.log("Custom design form found");


//   form.addEventListener("submit", function(e){

//     e.preventDefault();

//     console.log("Custom design submitted");
//     const title = document.getElementById("customDesignTitle");
//     const subtitle = document.getElementById("customDesignSubtitle");
//     // Hide title and subtitle
//     if (title) {
//         title.style.display = "none";
//     }

//     if (subtitle) {
//         subtitle.style.display = "none";
//     }

//     //show success message
//     if (result) {

//       result.innerHTML = `
//         <h3>Thank you for your inquiry! ✨</h3>

//         <p>
//         Your custom design request has been successfully submitted.
//         We will review your idea and get back to you as soon as possible.
//         </p>

//         <p>
//         Thank you for choosing Fusion Creations By KG 💛
//         </p>
//       `;

//       console.log("Success message added");

//     } else {

//       console.log("quizResult box not found");

//     }


//     // Hide form AFTER adding message
//     form.style.display = "none";


//   });

// });


document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("customDesignForm");
  const result = document.getElementById("customDesignResult");

  if (!form) {
    console.log("Custom design form not found on this page.");
    return;
  }

  form.addEventListener("submit", async function (e) {

    e.preventDefault();
    e.stopPropagation();

    console.log("Custom design form submitted!");

    const submitButton = form.querySelector(".find-submit");

    submitButton.disabled = true;
    submitButton.textContent = "Sending...";

    result.innerHTML = "";

    try {

      const formData = new FormData(form);

      const response = await fetch(
        "https://fusioncreationsshop.onrender.com/api/custom-design",
        {
          method: "POST",
          body: formData
        }
      );

      const data = await response.json();

      console.log("API RESPONSE:", data);

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Unable to send request.");
      }

      form.style.display = "none";
      document.getElementById("customDesignTitle").style.display = "none";
      document.getElementById("customDesignSubtitle").style.display = "none";

      result.innerHTML = `
        <div style="padding:20px; text-align:center;">
          <h3>Thank you for your inquiry! ✨</h3>
          <p>
            Your custom design request has been received.
            We will review your idea and contact you soon.
          </p>
        </div>
      `;

    } catch (error) {

      console.error("CUSTOM DESIGN ERROR:", error);

      result.innerHTML = `
        <div style="padding:20px; text-align:center;">
          <p style="color:#c00;">
            Something went wrong while sending your request.
            Please try again or email us directly.
          </p>
        </div>
      `;

      submitButton.disabled = false;
      submitButton.textContent = "Send My Design Request";
    }

  });

});